import React, { useState } from 'react'
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Pill } from 'lucide-react';

const MedicationsCalendar = ({ events, onEventClick }) => {
    const renderEventContent = (eventInfo) => {
        return (
            <div
                title={eventInfo.event.title}
                className="flex flex-wrap gap-1"
                style={{ maxWidth: '100%' }}
            >
                <div
                    className="w-5 h-5 bg-blue-600 text-white flex items-center justify-center rounded-full hover:shadow-md cursor-pointer"
                    style={{ minWidth: '20px' }}
                >
                    <Pill size={14} />
                </div>
            </div>
        );
    };



    return (
        <div>
            <FullCalendar
                headerToolbar={{
                    start: "prev,next today",
                    center: "title",
                    end: "dayGridMonth,timeGridWeek,timeGridDay",
                }}
                height="auto"
                plugins={[dayGridPlugin, interactionPlugin, timeGridPlugin]}
                initialView="dayGridMonth"
                events={events}
                eventContent={renderEventContent}
                eventClick={onEventClick}
                eventClassNames={() => 'p-0 m-0 w-fit h-fit'}
            />
        </div>
    )
}

export default MedicationsCalendar